<mat-list-item (click)="expanded = !expanded" class="parent">
  <div class="parent-content">
    <span class="title-menu">{{ text }}</span>
    <mat-icon fontSet="material-icons-outlined" class="accent-color">{{ icon }}</mat-icon>
    <mat-icon class="menu-button" [ngClass]="{'rotated': expanded}">expand_more</mat-icon>
  </div>
</mat-list-item>
@if (expanded) {
  <div class="submenu" [ngClass]="{'expanded': expanded}">
    <ng-content></ng-content>
  </div>
}